const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "padlock",
  className: "cls-1",
  d: "M18.307,8.747h-.729V5.831a5.831,5.831,0,0,0-11.663,0V8.747H5.187A2.189,2.189,0,0,0,3,10.934v10.2a2.189,2.189,0,0,0,2.187,2.187H18.307a2.189,2.189,0,0,0,2.187-2.187v-10.2A2.189,2.189,0,0,0,18.307,8.747ZM7.859,5.831a3.888,3.888,0,0,1,7.775,0V8.747H7.859Zm4.859,10.421v2.214a.972.972,0,1,1-1.944,0V16.252a1.944,1.944,0,1,1,1.944,0Z",
  transform: "translate(-3)"
});
function SvgLoginPasswordIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.494,
    height: 23.325,
    viewBox: "0 0 17.494 23.325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPasswordIcon);
export default __webpack_public_path__ + "static/media/login-password-icon.5dd8a5fcb7e95963c687fe301c5c5d74.svg";
export { ForwardRef as ReactComponent };